//import noImageToShow from '../../../../assets/noImageToShow.png'
import noImageToShow from '../../../../assets/Noimage.png'
import EditMode from './EditMode'
import AdminMode from './AdminMode'
import ViewMode from './ViewMode'

const useImageSlider = () => {
    const noImage = [{
        fieldData: noImageToShow,
        fieldId: "7e484b0-86af-a38e-27d4-2be0eb0cfa2",
        isMandatory: true,
        label: "",
        position: 0,
        type: "Text"
    }]

    const viewSwitcher = (onEditMode, admin, data, formikProps, index) => {
        if (onEditMode) {
            return <EditMode data={data} formikProps={formikProps} index={index} />
        } else if (admin) {
            return <AdminMode data={data} noImage={noImage} />
        } else {
            return <ViewMode data={data} />
        }
    }

    return {noImage, viewSwitcher}
}

export default useImageSlider